import { render, staticRenderFns } from "./b64.vue?vue&type=template&id=24ece3f2&scoped=true&"
import script from "./b64.vue?vue&type=script&lang=js&"
export * from "./b64.vue?vue&type=script&lang=js&"
import style0 from "./b64.vue?vue&type=style&index=0&id=24ece3f2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24ece3f2",
  null
  
)

export default component.exports